module.exports = __webpack_public_path__ + "static/media/twitter.f7dee22f.svg";